import { apiRequest } from "@/api";

const state = {
  WithAnalytics: {},
  visitors: undefined,
  botVisitors: undefined,
  onboarding: undefined,
  ProfilUtilisation: {
    CountryData: {},
  },
  SplitStatus: undefined,
  SplitSender: undefined,
  Conversations: undefined,
  ConversationSubjects: {},
  Rating: undefined,
  ConversationMajorTopics: undefined,
  MessagesTime: undefined,
};

function idSiteToIdMatomo(id) {
  const tab = {
    1: "no_tracking",
    6: 4, // Fraiche Paris
    7: 5, //Departement feminin
    18: 7, //Avrilgau
    20: 8, //Manfield
    25: 9, //Fete impérial
    23: 10, // Anahide
    26: 11, // Dada
    28: 12, // L'Exception
    33: 12, // L'Exception test
    35: 13, // Anja
    36: 14, //JG
    38: 15, // Gillis
    40: 16, // Osérée
    41: 17, // Gooseberry
    47: "no_tracking", //trench-and-coat
    50: 19, // Carven
    46: "no_tracking", //noo-paris
    87: "no_tracking", // MFK
    59: 23, // Formacast
    78: 24, // Rueil
    79: 25, // ARBS
    54: 26, // levallois
    88: 27, // Courbevoie
    95: 28, //sisley
    57: 29, //insidy
    141: 31, //French federation of franchise
    149: 34, // SIXSOEURS
    140: 35, // French federation of franchise
    131: 36, //intranet-mairie-rueilmalmaison
    139: 37, //BienManger
    160: 38, //Robot Rueil
  };
  return tab[id];
}

function getColor(value) {
  //value from 0 to 1
  var hue = ((1 - value) * 200).toString(10);
  return ["hsl(", hue, ",8%,60%)"].join("");
}

const mutations = {
  SET_ANALYTICS_VISIT: (state, data) => {
    console.log("SET_ANALYTICS_VISIT");
    if (data) {
      let result = data;
      if (typeof data === "string") {
        result = JSON.parse(data.replaceAll("NaN", "null"));
      }
      state.visitors = result;
    }
  },
  SET_ANALYTICS_VISITBOT: (state, data) => {
    console.log("SET_ANALYTICS_VISITBOT");
    if (data) {
      let result = data;
      if (typeof data === "string") {
        result = JSON.parse(data.replaceAll("NaN", "null"));
      }
      state.botVisitors = result;
    }
  },
  SET_ANALYTICS_ONBEARDING: (state, data) => {
    console.log("SET_ANALYTICS_ONBEARDING");
    if (data.nb_steps) state.onboarding = data.nb_steps;
  },
  SET_ANALYTICS_LOCATION: (state, data) => {
    console.log("SET_ANALYTICS_LOCATION");
    if (data.length) {
      state.ProfilUtilisation = {
        CountryData: {},
      };
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        state.ProfilUtilisation.CountryData[
          element.location_country.toUpperCase()
        ] = getColor(element.pourcentage);
      }
    }
    state.ProfilUtilisation.data = data;
  },
  SET_SPLIT_STATUS: (state, { data, dates }) => {
    console.log("SET_SPLIT_STATUS", data);
    if (data.data && data.data.length) {
      state.SplitStatus = { data: data.data, dates: dates };
    }
  },
  SET_SPLIT_SENDER: (state, { data, dates }) => {
    console.log("SET_SPLIT_SENDER");
    if (data.data && data.data.length) {
      state.SplitSender = { data: data.data, dates: dates };
    }
  },
  SET_CONVERSATIONS: (state, data) => {
    console.log("SET_CONVERSATIONS");
    if (data.data && data.data.length) {
      state.Conversations = data.data;
    }
  },
  SET_CONVERSATION_SUBJECTS: (state, data) => {
    console.log("SET_CONVERSATION_SUBJECTS");
    if (data.data === "Their is no conversation for this given period") {
      console.log("Their is no conversation for this given period");
      return;
    }
    if (data.data && data.data.length) {
      const result = data.data.reduce(function (r, a) {
        r[`${a.year}-${a.month}`] = r[`${a.year}-${a.month}`] || {
          conversation_subjects: {},
          receiver_ids: [],
          count: 0,
        };
        a.conversation_subject.forEach((element) => {
          if (!r[`${a.year}-${a.month}`].conversation_subjects[element]) {
            r[`${a.year}-${a.month}`].conversation_subjects[element] = 1;
          } else {
            r[`${a.year}-${a.month}`].conversation_subjects[element] += 1;
          }
        });

        r[`${a.year}-${a.month}`].receiver_ids.push(a.receiver_id);
        r[`${a.year}-${a.month}`].count =
          r[`${a.year}-${a.month}`].receiver_ids.length;
        return r;
      }, Object.create(null));
      state.ConversationSubjects = result;
    }
  },
  SET_RATING: (state, data) => {
    console.log("SET_RATING");
    if (data) {
      let result = data;
      if (typeof data === "string") {
        result = JSON.parse(data.replaceAll("NaN", "null"));
      }
      state.Rating = result;
    }
    // Debug
    console.log("RATING_NPS_CES:", state.Rating);
    console.log("RATING_NPS_CES:", data.data);
  },
  SET_CONVERSATIONS_MAJOR_TOPICS: (state, data) => {
    console.log("SET_CONVERSATIONS_MAJOR_TOPICS");
    if (data) {
      let result = data;
      if (typeof data === "string") {
        result = JSON.parse(data.replaceAll("NaN", "null"));
      }
      state.ConversationMajorTopics = result;
    }
    // Debug
    console.log("MAJOR_TOPICS:", data.data);
  },
  SET_MESSAGES_TIME: (state, data) => {
    console.log("SET_MESSAGES_TIME");
    if (data.data && data.data.length) {
      state.MessagesTime = data.data;
    }
  },
};

const actions = {
  ANALYTICS_STORE: async ({ rootState, state }) => {
    await new Promise((resolve, reject) => {
      const storeID = rootState.admin.storeId;
      const idSiteMatomo = idSiteToIdMatomo(storeID);
      if (idSiteMatomo === undefined) {
        state.WithAnalytics = { value: false };
        reject("store id not found");
      } else {
        state.WithAnalytics = {
          value: true,
          tracking: idSiteMatomo === "no_tracking" ? false : true,
        };
        resolve();
      }
    });
  },
  FETCH_ANALYTICS_VIS: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();

      apiRequest()
        .post(
          "analytics/GeneralVisits",
          {
            storeID,
            storeID2,
            dates,
          },
          {
            timeout: 600000,
          }
        )
        .then(({ data }) => {
          console.log("data vis", data);
          commit("SET_ANALYTICS_VISIT", data.data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_ANALYTICS_VISBOT: async (
    { rootState, commit },
    { dates, conversation_maker }
  ) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();

      apiRequest()
        .post(
          "analytics/GeneralVisitsBot",
          {
            storeID,
            storeID2,
            dates,
            conversation_maker,
          },
          {
            timeout: 600000,
          }
        )
        .then(({ data }) => {
          console.log("data bot", data);
          commit("SET_ANALYTICS_VISITBOT", data.data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_ANALYTICS_ONBOARDING: async (
    { rootState, commit },
    { dates, conversation_maker }
  ) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/Onboarding",
          {
            storeID,
            storeID2,
            dates,
            conversation_maker,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          console.log("data onboarding", data);
          commit("SET_ANALYTICS_ONBEARDING", data.data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_ANALYTICS_LOCATION: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();

      apiRequest()
        .post(
          "analytics/localisation",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          console.log(data);
          commit("SET_ANALYTICS_LOCATION", data.data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_SPLIT_STATUS: async (
    { rootState, commit },
    { dates, conversation_maker }
  ) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/split_status",
          {
            storeID,
            storeID2,
            dates,
            conversation_maker,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          commit("SET_SPLIT_STATUS", { data, dates });
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_SPLIT_SENDER: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/split_sender",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          commit("SET_SPLIT_SENDER", { data, dates });
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_SPLIT_CONVERSATIONS: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/conversation",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          console.log("conversation res", data);
          commit("SET_CONVERSATIONS", data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_CONVERSATION_SUBJECTS: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/conversationSubjects",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          console.log("conversationSubjects res", data);
          commit("SET_CONVERSATION_SUBJECTS", data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_RATING: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/rating",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          commit("SET_RATING", data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_CONVERSATIONS_MAJOR_TOPICS: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/topics",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          commit("SET_CONVERSATIONS_MAJOR_TOPICS", data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
  FETCH_MESSAGES_TIME: async ({ rootState, commit }, { dates }) =>
    await new Promise((resolve, reject) => {
      const storeID2 = rootState.admin.storeId;
      if (idSiteToIdMatomo(storeID2) === undefined)
        reject("store id not found");
      const storeID = idSiteToIdMatomo(storeID2).toString();
      apiRequest()
        .post(
          "analytics/messages_time",
          {
            storeID,
            storeID2,
            dates,
          },
          { timeout: 600000 }
        )
        .then(({ data }) => {
          console.log(data);
          commit("SET_MESSAGES_TIME", data);
          resolve(data);
        })
        .catch((e) => {
          console.log("error", e);
          reject(e);
        });
    }),
};

export default { state, mutations, actions };
